export let addRule = {
    title: [
        { required: true, message: "请填写合作商名称", trigger: "change" },
    ],
    name: [
        { required: true, message: "请填写联系人", trigger: "change" },
    ],
    phone: [
        { required: true, message: "请填写联系人电话", trigger: "change" },
    ],
    type: [
        { required: true, message: "请选择类型", trigger: "change" },
    ],
    city: [
        { required: true, message: "请选择城市", trigger: "change" },
    ],
    login_name: [
        { required: true, message: "请填写登录账号", trigger: "change" },
    ],

}

